import { normalizeRole } from '@/auth/permissions';

type DotsIdentity = {
  id?: string | null;
  email?: string | null;
  role?: string | null;
};

const PERSONAL_DOTS_ONLY_USER_IDS = new Set([
  '7d61c348-2369-488e-8133-579ff7ea7d6b',
]);

const PERSONAL_DOTS_ONLY_EMAILS = new Set([
  'camorlinga@sien.com',
  'luis.camorlinga@sienindustrial.com.mx',
]);

export function isPersonalDotsOnlyUser(identity?: DotsIdentity | null): boolean {
  const id = String(identity?.id ?? '').trim().toLowerCase();
  const email = String(identity?.email ?? '').trim().toLowerCase();
  return PERSONAL_DOTS_ONLY_USER_IDS.has(id) || PERSONAL_DOTS_ONLY_EMAILS.has(email);
}

export function canAccessAdminDots(identity?: DotsIdentity | null): boolean {
  const role = normalizeRole(identity?.role);
  return (role === 'ADMIN' || role === 'RH') && !isPersonalDotsOnlyUser(identity);
}
